// Components==============
import { motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './DreamItems.module.scss';
// =========================

const transition = {
  type: 'spring',
  stiffness: 500,
  damping: 30,
};

const initialProject = { x: 30, y: 52, scale: 0.5, transition };
const initialActivity = { x: 0, y: 52, scale: 0.5, transition };
const initialSparks = { x: -30, y: 52, scale: 0.5, transition };

const animateProject = { x: 25, y: -16, scale: 0.9, transition };
const animateActivity = { x: 0, y: 25, scale: 1, transition };
const animateSparks = { x: -25, y: -16, scale: 0.9, transition };

export default function DreamItems({
  hovering,
  dream,
}: {
  hovering: boolean;
  dream: DreamEntity;
}) {
  const translate = useTranslate();

  const projects = dream.contributed_projects?.length || 0;

  const sparks = dream?.reflections?.map((r) => r.sparks).flat().length || 0;

  const requirementActivities = dream.requirements
    .filter((r) => r.requirement_type !== 'App\\Skill')
    .map((r) => r.done);

  const contributedActivities =
    dream?.contributed_activities?.map((r) => r.amount) || [];

  const activities = [
    ...requirementActivities,
    ...contributedActivities,
  ].reduce((a, b) => (a || 0) + (b || 0), 0);

  return (
    <motion.div
      styleName={`wrapper ${hovering ? 'hovering' : ''}`}
      animate={{ scale: hovering ? 1.8 : 1 }}
      initial={{ scale: 1 }}
    >
      {!!projects && (
        <motion.div
          styleName="projects"
          initial={initialProject}
          animate={hovering ? animateProject : initialProject}
        >
          <strong>{projects}</strong>
          <p>
            {translate(
              `general.terms.${projects > 1 ? 'projects' : 'project'}`
            )}
          </p>
        </motion.div>
      )}
      {!!sparks && (
        <motion.div
          styleName="sparks"
          initial={initialSparks}
          animate={hovering ? animateSparks : initialSparks}
        >
          <strong>{sparks}</strong>
          <p>spark{sparks > 1 ? 's' : ''}</p>
        </motion.div>
      )}
      {!!activities && (
        <motion.div
          styleName="activities"
          initial={initialActivity}
          animate={hovering ? animateActivity : initialActivity}
        >
          <strong>{activities}</strong>
          <p>
            {translate(
              `project.terms.${activities > 1 ? 'activities' : 'activity'}`
            )}
          </p>
        </motion.div>
      )}
    </motion.div>
  );
}
